import React from 'react';
import { FormattedMessage } from 'react-intl';

import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import { purchaseOrderGridProperties } from '../../data/purchase-order-properties';
import { messages } from '../messages';

const name = <FormattedMessage {...messages.expectedDeliveryDateColumnHeader} />;

/**
 * Expected Delivery Date column configuration
 * Displays the expected delivery date of the purchase order
 * Uses UserDateTimezoneFormat to format the date according to user's timezone
 * @type {import('./types').GridColumn} Column configuration object
 */
export const expectedDeliveryDateColumn = {
  name,
  render: (data) => {
    const { expectedDeliveryDate } = data;
    return expectedDeliveryDate && <UserDateTimezoneFormat dateTime={expectedDeliveryDate} />;
  },
  id: purchaseOrderGridProperties.expectedDeliveryDate,
};
